import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Routes_path } from "components/routerApp";

// Material UI
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import HomeIcon from "@mui/icons-material/Home";
import InventoryIcon from "@mui/icons-material/Inventory";
import { styled } from "@mui/material/styles";
import ListAltIcon from "@mui/icons-material/ListAlt";

// ============================================
// STYLED COMPONENTS
// ============================================

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
    "& .MuiBreadcrumbs-ol": {
        alignItems: "center",
    },
    "& .MuiTypography-root": {
        display: "flex",
        alignItems: "center",
    },
}));

const LinkRouter = styled(Link)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
    },
}));

const IconWrapper = styled("span")(({ theme }) => ({
    marginRight: theme.spacing(0.5),
    display: "flex",
    alignItems: "center",
}));

// ============================================
// COMPONENT
// ============================================

const PrevisioniPageBreadcrumbs = () => {
    const location = useLocation();
    const pathSegments = location.pathname.split("/").filter(Boolean);

    // Determina se siamo nella lista o nel dettaglio
    const isDettaglio = pathSegments.length > 1 && !isNaN(Number(pathSegments[pathSegments.length - 1]));
    const isNuovo = location.pathname === Routes_path.PREVISIONE;

    return (
        <StyledBreadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
        >
            {/* Home */}
            <LinkRouter to={Routes_path.HOME}>
                <IconWrapper>
                    <HomeIcon fontSize="small" />
                </IconWrapper>
                Home
            </LinkRouter>

            {/* Lista Previsioni */}
            {(isDettaglio || isNuovo) ? (
                <LinkRouter to={Routes_path.PREVISIONI}>
                    <IconWrapper>
                        <ListAltIcon fontSize="small" />
                    </IconWrapper>
                    Listini
                </LinkRouter>
            ) : (
                <Typography color="text.primary">
                    <IconWrapper>
                        <ListAltIcon fontSize="small" />
                    </IconWrapper>
                    Listini
                </Typography>
            )}

            {/* Dettaglio/Nuovo */}
            {isDettaglio && (
                <Typography color="text.primary">
                    Dettaglio Listino
                </Typography>
            )}

            {isNuovo && !isDettaglio && (
                <Typography color="text.primary">
                    Nuova Listino
                </Typography>
            )}
        </StyledBreadcrumbs>
    );
};

export default PrevisioniPageBreadcrumbs;